<div class="back_rotate" *ngIf="isOrientaionChanged">
  <img src="assets/img/smartphone_1.svg">
  <h3 class="back_rotate_t">گوشی خود را بچرخانید</h3>
  <div class="back_rotate_txt">
    <p>امکان مشاهده در این سایز وجود ندارد</p>
  </div>
</div>
